import { put, call } from 'redux-saga/effects';
import { departmentCreateAPI, departmentSearchAPI, departmentUpdateAPI } from 'src/api/DepartmentApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { DEPARTMENT_ACTIONS } from '../actions/DepartmentActions';
import { toast } from 'react-toastify';

function* search({
    where, currentPage = 0, autopopulate = true, fullTextSearch = true,
} = {}) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(departmentSearchAPI, {
            where,           
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });

        yield put({
            type: DEPARTMENT_ACTIONS.DEPARTMENT_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: DEPARTMENT_ACTIONS.DEPARTMENT_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({
    _id,
}) {
    try {
        const {
            data: {
                data: {
                    data,
                },
            },
        } = yield call(departmentSearchAPI, {
            where: {
                _id,
            },
            autopopulate: false,
        });

        if (!data || !data[0]) {
            
            yield put(headerShowAction({
                data: 'Unable to Edit, something when wrong',
            }));
        }

        
        yield put({
            type: DEPARTMENT_ACTIONS.DEPARTMENT_UPSERT_SUCCESS,
            data: data[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* insert(payload) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(departmentCreateAPI, payload);

        yield put(headerShowAction({
            data: 'Created',
        })); 
        toast("Department Created")
        
        yield put({
            type: DEPARTMENT_ACTIONS.DEPARTMENT_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data._id,
            },
        });
        yield put({
            type: DEPARTMENT_ACTIONS.DEPARTMENT_SEARCH
        });
    }
    catch (error) {
        // console.error('LOG: upsert error', error);
        // yield put(headerShowAction({
        //     data: error.response.data.data,
        // }));
        toast.error(error.response.data.message);
        yield put({
            type: DEPARTMENT_ACTIONS.DEPARTMENT_UPSERT_ERROR,
        });
    }
}

function* update(departmentId, payload) {
    try {
        yield call(departmentUpdateAPI, {
            departmentId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));
        if(payload.deleted===true){
            toast("Department deleted")
        }
        else{
            toast("Department updated")
        } 
        
        yield put({
            type: DEPARTMENT_ACTIONS.DEPARTMENT_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: DEPARTMENT_ACTIONS.DEPARTMENT_UPSERT_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(DEPARTMENT_ACTIONS.DEPARTMENT_SEARCH, search),
    takeFirstSagaUtil(DEPARTMENT_ACTIONS.DEPARTMENT_UPSERT, upsert),
    takeFirstSagaUtil(DEPARTMENT_ACTIONS.DEPARTMENT_EDIT, edit),
];
